export default __webpack_public_path__ + "static/media/athena.7ed6827a.png";